/**
 * @file 异常情况
 * @author lijie44<lijie44@baidu.com>
 * stateData: 0-默认状态、1-数据拉取成功、2-prompt不存在，3-接口请求失败 4-loading
 */
import {PAGE_STATE_CONFIG} from '@lib/constants';
import {Component} from '@src/lib/San';
import $style from './index.module.less';
import lottieEmpty from './lottieEmpty.json';
import lottieNetworkFail from './lottieNetworkFail.json';
import lottieServerFail from './lottieServerFail.json';

export default class CAbnormal extends Component {
    static template = `
        <div
            class="{{$style.cAbnormal}} {{fullScreen ? '' : $style.autoHeight}}"
        >
            <div s-if="!isLoading" class="{{$style.content}}">
                <div
                    s-if="showStaticImage"
                    class="
                    {{$style.iconStatic}}
                    {{isServerFail ? $style.server : ''}}
                    {{isNetworkFail ? $style.network : ''}}"
                ></div>
                <div
                    s-if="!showStaticImage"
                    s-ref="abnormal-lottie"
                    class="{{$style.icon}}"
                ></div>
                <div s-if="title && showTitle" class="{{$style.title}}">
                    {{ title }}
                </div>
                <template s-if="!forceShowMessage">
                    <p s-if="{{stateData === PAGE_STATE_CONFIG.NODATA}}">
                        {{ noDataTips }}
                    </p>
                    <p s-if="isFail || isServerFail">
                        请重新检查网络连接后重试
                    </p>
                    <p s-else-if="isNetworkFail">
                        请检查网络设置后点击“重试”
                    </p>
                </template>
                <p s-else>
                    {{ forceShowMessage }}
                </p>
                <div
                    s-if="showRetry"
                    class="{{$style.retry}}"
                    on-click="retry"
                >
                    {{ retryText ? retryText : '重试一下' }}
                </div>
            </div>
            <div s-if="isLoading" class="{{$style.loading}}"></div>
        </div>`;

    static computed: Computed = {
        showRetry() {
            const stateData = this.data.get('stateData');
            const retryText = this.data.get('retryText');
            return stateData === PAGE_STATE_CONFIG.FAIL
                || stateData === PAGE_STATE_CONFIG.SERVER_FAIL
                || stateData === PAGE_STATE_CONFIG.NETWORK_FAIL
                || retryText;
        },
        isLoading() {
            const stateData = this.data.get('stateData');
            return stateData === PAGE_STATE_CONFIG.LOADING;
        },
        isFail() {
            const stateData = this.data.get('stateData');
            return stateData === PAGE_STATE_CONFIG.FAIL;
        },
        isServerFail() {
            const stateData = this.data.get('stateData');
            return stateData === PAGE_STATE_CONFIG.SERVER_FAIL;
        },
        isNetworkFail() {
            const stateData = this.data.get('stateData');
            return stateData === PAGE_STATE_CONFIG.NETWORK_FAIL;
        },
        title() {
            const stateData = this.data.get('stateData');
            switch (stateData) {
                case PAGE_STATE_CONFIG.NODATA:
                    return this.data.get('customTitle') || '这里空空如也...';
                case PAGE_STATE_CONFIG.FAIL:
                    return '服务器休息一下～ 马上回来！';
                case PAGE_STATE_CONFIG.SERVER_FAIL:
                    return '服务器休息一下～ 马上回来！';
                case PAGE_STATE_CONFIG.NETWORK_FAIL:
                    return '网络失联啦！';
                default:
                    return '';
            }
        },
    };

    __abnormalLottie: any;

    retry() {
        this.fire('retry');
    }

    initData() {
        return {
            $style,
            PAGE_STATE_CONFIG,
            isShowLoading: false,
            noDataTips: '这里空空的～ 什么也没有～',
            // 是否全屏
            fullScreen: true,
            forceShowMessage: '',
            showStaticImage: false,
            showTitle: true,
        };
    }

    attached() {
        this.watch('isLoading', val => {
            !val && this.data.set('showStaticImage', false);
            this.nextTick(() => {
                !val && this.initLottie();
            });
        });
        this.initLottie();
    }

    initLottie() {
        if (this.ref('abnormal-lottie') && window.lottie) {
            const isServerFail = this.data.get('isServerFail');
            const isNetworkFail = this.data.get('isNetworkFail');
            const animationData = isNetworkFail
                ? lottieNetworkFail
                : isServerFail
                    ? lottieServerFail
                    : lottieEmpty;
            this.__abnormalLottie = window.lottie?.loadAnimation({
                container: this.ref('abnormal-lottie'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData,
            });
        }
        else {
            this.data.set('showStaticImage', true);
        }
    }

    detached() {
        this.__abnormalLottie?.destroy();
        this.__abnormalLottie = null;
    }
}
